import styled, { css } from 'styled-components';

export const ConnectedTwitterCardWrapper = styled.div`
    width: 100%;
    max-width: 420px;
    border-top: 1px solid ${({ theme }) => theme.shades.white[10]};
    padding: 30px 0;
    margin-top: 60px;
    display: flex;
    align-items: center;
`;

export const HandleText = styled.p`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 110%;
    letter-spacing: -0.03em;
    color: ${({ theme }) => theme.colors.white};
    margin: 0 0 2px 0;
    padding: 0;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: 16px;
    }
`;

export const AddedText = styled.p`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 120%;
    letter-spacing: -0.03em;
    color: ${({ theme }) => theme.shades.white[30]};
    margin: 0;
    padding: 0;
`;

export const LabelWrapper = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
`;

export const TwitterBadgeWrapper = styled.div`
    width: 48px;
    min-width: 48px;
    height: 48px;
    background: rgba(29, 155, 240, 0.12);
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;
    svg {
        width: 30px;
        fill: #1d9bf0;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 52px;
        min-width: 52px;
        height: 52px;
    }
`;

export const ConnectedBadgeWrapper = styled.div<{ isMobile: boolean }>`
    padding: 3px 11px;
    gap: 6px;
    width: 97px;
    height: 26px;
    background: rgba(98, 250, 113, 0.1);
    border-radius: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: none;
    }
    ${({ isMobile }) =>
        isMobile &&
        css`
            display: none;
            background: transparent;
            padding: 0;
            width: unset;
            height: unset;
            @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
                display: flex;
            }
        `};
`;

export const ConnectedBadgeLabel = styled.div`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 130%;
    text-align: center;
    letter-spacing: -0.02em;
    color: #62fa71;
`;

export const ConnectedBulletPoint = styled.div`
    width: 6px;
    height: 6px;
    background: #62fa71;
    border-radius: 50%;
`;

export const TrashButtonWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 13px 7px;
    gap: 4px;
    min-width: 36px;
    height: 26px;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 20px;
    cursor: pointer;
    z-index: 5;
    margin-left: 8px;
    transition: background 0.2s ease;
    &:hover {
        background: rgba(255, 255, 255, 0.1);
    }
`;
